import React from 'react';
import ImageHero from 'presentation/assets/images/recording_hero.jpg';

const Hero = () => (
  <div className='max-w-screen-xl mt-24 px-8 xl:px-16 mx-auto' id='home'>
    <div className='grid grid-flow-row sm:grid-flow-col grid-rows-2 md:grid-rows-1 sm:grid-cols-2 gap-8 py-6 sm:py-16'>
      <div className=' flex flex-col justify-center items-start row-start-2 sm:row-start-1'>
        <h1 className='text-3xl lg:text-4xl xl:text-5xl font-medium text-black-600 leading-normal mb-8'>
          Busca la grabación de tu <strong>Clase</strong>.
        </h1>
        <form className='bg-gray-500 opacity-75 w-full shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4'>
          <div className='mb-4'>
            <label
              className='block text-blue-300 py-2 font-bold mb-4'
              htmlFor='emailaddress'
            >
              Ingresa el ID del zoom
              <input
                className='shadow appearance-none border rounded w-full mt-4 p-3 text-gray-700 leading-tight focus:ring transform transition hover:scale-105 duration-300 ease-in-out'
                id='emailaddress'
                type='text'
                placeholder='ID Zoom'
              />
            </label>
          </div>

          <div className='flex items-center justify-between pt-4'>
            <button
              className='py-3 lg:py-4 px-12 lg:px-16 text-white-500 font-semibold rounded-lg bg-green-800 hover:shadow-green-md transition-all outline-none'
              type='button'
            >
              Buscar
            </button>
          </div>
        </form>
      </div>
      <div className='flex w-full'>
        <div className='h-full w-full'>
          <img className='w-auto' src={ImageHero} alt='Buscar grabaciones' />
        </div>
      </div>
    </div>
  </div>
);

export default Hero;
